import nBossConnection from 'modules/base/service/nBossConnection';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import SimulationMonitorTableService from '../service/SimulationMonitorTableService';

const config = {
	key: 'simulationMonitorTable',
	topic: 'simulationMonitor',
	service: SimulationMonitorTableService,
	editFormState: item => `/simulation-monitor/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['exportData', 'modify', 'delete'],
	exportData: {
		tooltip: 'Export to XLSX',
		link: item => `${nBossConnection.basePath}simulationMonitorTableControl/exportToXlsx?id=${item.id}`
	},
	columns: [
		{
			key: 'name'
		}
	]
};

function SimulationMonitorTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('simulationMonitorTable', reducer('simulationMonitorTable'))(SimulationMonitorTable);
